module.exports = __webpack_public_path__ + "static/media/invoice_send.7e26359a.png";